import PropTypes from 'prop-types'
import React from 'react'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { getCurrentAd, getSpecsIdForMainProps } from '../../../selectors'

export const List = ({ad, specs}) => {
  const items = []
  if (Array.isArray(ad.adsSpecifications)) {
    specs.forEach(item => {
      const arSpecification = ad.adsSpecifications.filter(
        specification => specification.specification && specification.specification.id === item
      )
      if (arSpecification.length) {
        items.push({
          id: arSpecification[0].id,
          ico: arSpecification[0].specification.icon,
          iconSvg: arSpecification[0].specification.iconSvg,
          value: arSpecification[0].value,
          unit: arSpecification[0].specification.measure,
          title: arSpecification[0].specification.title.toLowerCase()
        })
      }
    })
  }

  return (
    <div className='oglasi-glavne-informacije'>
      {
        items.map(item => (
          <Item
            key={item.id}
            icon={item.ico}
            iconSvg={item.iconSvg}
            unit={item.unit}
            value={item.value}
            title={item.title}
          />
        ))
      }
    </div>
  )
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state),
  specs: getSpecsIdForMainProps(state)
})

List.propTypes = {
  ad: PropTypes.shape({
    adsSpecifications: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      specification: PropTypes.object.isRequired
    }))
  }).isRequired,
  specs: PropTypes.arrayOf(PropTypes.number)
}

List.defaultProps = {
  specs: []
}

List.displayName = 'MainProps'

export default connect(mapStateToProps)(List)
